<template>
    <div class="divstep">
        <div class="divnivel">
            <div class="circle-step-outside" :class="{'circle-step-outside-green': nivel >= 0}">
                <div class="circle-step-inside" :class="{'circle-step-inside-green': nivel >=  0}">
                    <i class="fas fa-check" v-if=" nivel > 0"></i>
                </div>
            </div>
            <div :class="{'steptext-green': nivel >=  0, 'steptext': nivel < 0}"><b>Patologias</b></div>
            <div  :class="{'linestep-green': nivel >=  0, 'linestep': nivel < 0}"></div>
        </div>
        <div class="divnivel">
            <div class="circle-step-outside" :class="{'circle-step-outside-green': nivel >= 1}">
                <div class="circle-step-inside" :class="{'circle-step-inside-green': nivel >=  1}">
                    <i class="fas fa-check" v-if=" nivel > 1"></i>
                </div>
            </div>
            <div :class="{'steptext-green': nivel >=  1, 'steptext': nivel < 1}"><b>Descrição</b></div>
            <div  :class="{'linestep-green': nivel >=  1, 'linestep': nivel < 1}"></div>
        </div>
        <div class="divnivel">
            <div class="circle-step-outside" :class="{'circle-step-outside-green': nivel >=2}">
                <div class="circle-step-inside" :class="{'circle-step-inside-green': nivel >= 2}">
                    <i class="fas fa-check" v-if=" nivel >2"></i>
                </div>
            </div>
            <div :class="{'steptext-green': nivel >= 2, 'steptext': nivel <2}"><b>Triagem</b></div>
            <div  :class="{'linestep-green': nivel >= 2, 'linestep': nivel <2}"></div>
        </div>
        <!-- <div class="divnivel">
            <div class="circle-step-outside" :class="{'circle-step-outside-green': nivel >= 3}">
                <div class="circle-step-inside" :class="{'circle-step-inside-green': nivel >=  3}">
                    <i class="fas fa-check" v-if=" nivel > 3"></i>
                </div>
            </div>
            <div :class="{'steptext-green': nivel >=  3, 'steptext': nivel < 3}"><b>Data</b></div>
            <div  :class="{'linestep-green': nivel >=  3, 'linestep': nivel < 3}"></div>
        </div> -->
        <div class="divnivel">
            <div class="circle-step-outside" :class="{'circle-step-outside-green': nivel >= 3}">
                <div class="circle-step-inside" :class="{'circle-step-inside-green': nivel >=  3}">
                    <i class="fas fa-check" v-if=" nivel > 3"></i>
                </div>
            </div>
            <div :class="{'steptext-green': nivel >=  3, 'steptext': nivel < 3}"><b>Resumo</b></div>
        </div>
    </div>
</template>

<script>
import stepocurrence from './stepocurrence'
export default stepocurrence
</script>

<style scoped>

.circle-step-inside{
    background-color: #DEDEDE;
    width: 20px;
    height: 20px;
    display: flex;
    color: white;
    font-weight: bold;
    border-radius: 50%;
}

.circle-step-inside-green{
    background-color: #008148;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-weight: bold;
    border-radius: 50%;
}

.circle-step-outside-green{
    width: 25px;
    height: 25px;
    border-radius: 50%;
    box-shadow: 0px 0px 0px 2px #008148;
    opacity: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.steptext-green{
    color: #008148;
    justify-self: left;
    font-size: 15px;
}

.steptext{
    color: #DEDEDE;
    justify-self: left;
    font-size: 15px;
}
.linestep-green{
    background-color:#008148;
    height: 100%;
    width: 1.5px;
}

.linestep{
    background-color:#DEDEDE;
    height: 100%;
    width: 1.5px;
}

.divnivel{
    display: grid;
    place-items: center;
    place-self: stretch;
    justify-self: stretch;
    grid-template-columns: 35% 65%;
    grid-template-rows: 35% 60%;
}

.divstep{
    display: grid;
    font-family: 'Segoe UI';
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/ocurrence/components/stepocurrence/stepocurrence.vue